import React, { useEffect } from "react";
import {
  Toolbar,
  IconButton,
  Typography,
  Box,
  Grid,
  ToggleButton,
  ToggleButtonGroup,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { styled } from "@mui/material/styles";
import { Outlet } from "react-router-dom";
import {
  authSelector,
  setUserBusinessType,
  userLoanCatSelector,
} from "../../services/redux/slices/authSlice";
import { useSelector } from "react-redux";
import { RootState } from "../../services/redux/store";
import { useDispatch } from "react-redux";
import { setDocumentDiscardModal } from "../../services/redux/slices/documentFormSlice";
import { setNotificationtype } from "../../services/redux/slices/notificationSlice";
import { setSelectedIndex, setTabType } from '../../services/redux/slices/tabsSlice';
import { setloanAccountNumberOptions, setSelectedloanAccountNumber } from "../../services/redux/slices/optionSlice";
import { setSelectedLoanNumber } from "../../services/redux/slices/dashboardDataSlice";


interface MainHeadingLoansProps {
  setToggle?: (value: string) => void; // Pass string directly
}
interface CustomToggleButtonProps {
  ownerState?: {
    selected: boolean;
  };
}

const CustomToggleButton = styled(ToggleButton, {
  shouldForwardProp: (prop) => prop !== "ownerState",
})<CustomToggleButtonProps>(({ theme, ownerState }) => ({
  ...(ownerState?.selected && {
    backgroundColor: theme.palette.primary.main,
    color: "#072c2c",
    boxShadow: `0px 4px 12px 0px #5A5A5A2B`,
    background: `#fff`,
    borderRadius: `5px`,
    fontWeight: 600,
  }),
}));

const MainHeadingLoans: React.FC<MainHeadingLoansProps> = ({ setToggle }) => {
  const { loanCategory } = useSelector(authSelector);
  const navigate = useNavigate();
  const tabType = useSelector((state: RootState) => state.tabs.tabType);
  const selectedIndex = useSelector((state: RootState) => state.tabs.selectedIndex);
  const [alignment, setAlignment] = React.useState<string>(tabType);
  const dispatch = useDispatch();

  const stateValue = useSelector((state: RootState) => state);

  // New: showButtons state managed by localStorage
  const [showButtons, setShowButtons] = React.useState<boolean>(false);

  const theme = useTheme();
  const isXsOrSm = useMediaQuery(theme.breakpoints.down("sm"));

  // Ensure tabType is set in localStorage if not present
  useEffect(() => {
    // On mount, do not set tabType in localStorage
  }, []);

  useEffect(() => {
    // Try to get showButtons from localStorage
    const showButtonsLS = localStorage.getItem("showButtons");
    if (showButtonsLS !== null) {
      setShowButtons(showButtonsLS === "true");
      if(showButtonsLS === "true"){
         //dispatch(setTabType("Term Loan"));
      }
    } else {
      // Fallback to Redux logic if not set in localStorage
      setShowButtons(
        loanCategory.Flexi.length > 0 && loanCategory.TermLoan.length > 0
      );
      if(loanCategory.Flexi.length > 0 && loanCategory.TermLoan.length > 0){
         //dispatch(setTabType("Term Loan"));
      }
    }
    //dispatch(setNotificationtype("Term Loan"));
  }, [loanCategory, dispatch]);
  
  useEffect(() => {
    setAlignment(tabType);
  }, [tabType]);

  const userLoanCategory = useSelector(userLoanCatSelector);

  const handleChange = (
    event: React.MouseEvent<HTMLElement>,
    newAlignment: string | null
  ) => {
   
    if (newAlignment == "Term Loan") {
      dispatch(setTabType("Term Loan"));

      dispatch(setloanAccountNumberOptions([]))
      dispatch(setSelectedLoanNumber(""))
      dispatch(setNotificationtype("Term Loan"));
      dispatch(
        setUserBusinessType({
          id: userLoanCategory?.TermLoan[0]?.businessId,
          name: "retail",
        })
      );
    } else {
      dispatch(setTabType("Flexi Term Loan"));
      dispatch(setNotificationtype("Flexi Term Loan"));
      dispatch(setloanAccountNumberOptions([]))
      dispatch(setSelectedLoanNumber(""))
      
      dispatch(
        setUserBusinessType({
          id: userLoanCategory?.Flexi[0]?.businessId,
          name: "flexi",
        })
      );
    }
    if (newAlignment !== null) {
      setAlignment(newAlignment);
      if (setToggle) {
        setToggle(newAlignment); // This will update the alignment in MainDashboard
      }
    }
    dispatch(setSelectedIndex(0));
  };

  const selectedFormType = useSelector(
    (state: RootState) => state?.documentFormSlice
  );
  const handleBackButton = () => {
    if (
      selectedFormType?.formType === "continue" &&
      selectedFormType?.isNewData
    ) {
      dispatch(setDocumentDiscardModal());
    } else {
      navigate(-1);
    }
  };

  return (
    <Box>
      <Grid container>
        <Box display="flex" flexDirection="column" alignItems="flex-end">
          {(showButtons && selectedIndex === 0) && (
            <ToggleButtonGroup
              value={tabType}
              exclusive
              onChange={handleChange}
              sx={{
                height: "40px",
                backgroundColor: "#eaf3f5", // container bg
                borderRadius: "7px",
                padding: "4px",
                display: "inline-flex",
                border: "none", // remove group border
                width: isXsOrSm  ? "200px" : "200px",
                gap: "6px",
                marginTop: "10px"
              }}
            >
              <ToggleButton
                value="Term Loan"
                sx={{
                  flex: 1,
                  borderRadius: "6px !important", // fully rounded
                  textTransform: "none",
                  border: "none", // remove inner borders
                  fontWeight: "bold",
                  "&.Mui-selected": {
                    backgroundColor: "#ffffff",
                    color: "#0e8a9e",
                  },
                  "&:hover": {
                    backgroundColor: "#ffffff",
                  },
                  "&.Mui-selected:hover": {
                    backgroundColor: "#ffffff", // Ensures no hover effect when selected
                  },
                  "&.Mui-focusVisible": {
                    backgroundColor: "#ffffff",
                  },
                  padding: "0px 11px",
                }}
              >
                Term Loan
              </ToggleButton>
              <ToggleButton
                value="Flexi Term Loan"
                sx={{
                  flex: 1,
                  borderRadius: "6px !important", // fully rounded
                  textTransform: "none",
                  border: "none", // remove inner borders
                  fontWeight: "bold",
                  "&.Mui-selected": {
                    backgroundColor: "#ffffff",
                    color: "#0e8a9e",
                  },
                  "&:hover": {
                    backgroundColor: "#ffffff",
                  },
                  "&.Mui-selected:hover": {
                    backgroundColor: "#ffffff", // Ensures no hover effect when selected
                  },
                  "&.Mui-focusVisible": {
                    backgroundColor: "#ffffff",
                  },
                  padding: "0px 11px",
                }}
              >
                Flexi Term
              </ToggleButton>
            </ToggleButtonGroup>
          )}
        </Box>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <Box mt={2}>{alignment === "Term Loan" && <Outlet />}</Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default MainHeadingLoans;
